/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const sidebarStyle = {
  sidebar: {
    width: "21rem"
  },
  paper: {
    width: "21rem"
  }
}
